<div>
  <div class="prose">
    <h1>DES Credits</h1>
  </div>

  @if (error) {
    <div class="mt-4">
      <p class="text-error">{{ error }}</p>
    </div>
  } @else if (loading && records.length === 0) {
    <div class="mt-4 flex justify-center">
      <div class="loading loading-spinner loading-lg"></div>
    </div>
  } @else if (records.length === 0) {
    <p class="mt-4 italic text-base-content/70">No DES credit record found</p>
    @if (isApiCustomer) {
      <p class="mt-4">
        Please contact support to assist in initializing your DES credits.
      </p>
    } @else {
      <p class="mt-4">
        To initialize your DES credits you must first open the AccuZIP desktop
        application and go to Special &gt; Data Enhancement Services &gt; Process
        List.
      </p>
      <p class="mt-2">
        Afterwards refresh this page and you should see your new DES credit
        record.
      </p>
    }
  } @else {
    @if (desApiKeyLink?.lookup_error) {
      <p class="mb-3 mt-4 text-error">
        An error occurred while looking up your DES credit record. Please try
        again later. If this error persists, please contact support.
      </p>
    }

    <div class="mt-8 overflow-x-auto rounded-lg border border-base-content/20">
      <table class="table table-zebra table-lg">
        <thead class="text-base font-medium">
          <tr>
            <td>Credits</td>
            <td>
              Computer Name
              <app-info-circle-icon
                class="tooltip tooltip-bottom ml-1 inline-block h-4 w-4 text-current"
                data-tip="The name of the computer that the DES credit was initially purchased on"
              ></app-info-circle-icon>
            </td>
            @if (isApiCustomer) {
              <td>Linked to API Key</td>
            }
            <td></td>
          </tr>
        </thead>
        <tbody>
          @for (rec of records; track rec.registration_id) {
            <tr>
              <td class="text-lg font-semibold">
                @if (displayCredit(rec) == '—') {
                  —
                } @else {
                  {{ displayCredit(rec) | number: '1.0-0' }}
                }
              </td>
              <td>{{ rec.computername || '—' }}</td>
              @if (isApiCustomer) {
                <td>
                  @if (rec.linked_to_api_key) {
                    <app-check-circle-icon
                      class="inline-block h-6 w-6 text-success"
                    ></app-check-circle-icon>
                  }
                </td>
              }
              <td class="text-right">
                <button
                  type="button"
                  class="btn btn-primary btn-sm w-36"
                  (click)="buyCredits(rec)"
                >
                  Purchase Credits
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
